export const storeDeepLink = async (Branch, client, history) => {
  const data = await Branch.initSession()
  if (data['+clicked_branch_link']) {
    // if we are at the login screen, save deep link so Navi can redirect properly
    if (history.location.pathname === '/login' || history.location.pathname === '/')
      client.writeQuery({ data: { deepLink: data.url } })
    history.push(data.url)
  }
}
